$(document).ready(function() {
    if ($('body.page-nuovoUtente').length) {

        $('[name="all-spunte"]').on('change',function() {

            $('#spunte-privacy input').prop('checked',$(this).is(':checked'));
        });

        $("#user_registration").on('submit',function() {
            $("#user_registration button[type='submit']").attr('disabled','disabled').html('<i class="fas fa-spinner fa-spin" aria-hidden="true"></i>');
        });

        $('#informazioni-utili').on('click',function() {
            $(this).find('i').toggleClass('active');
        });
    }
});